import React, {createContext, useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export const SavedSearchContext = createContext();

const SavedSearchContextProvider = (props) => {
    const location = useLocation();

    const [activeSavedSearch, setActiveSavedSearch] = useState(null);
    const [updatingSavedSearchCount, setUpdatingSavedSearchCount] = useState(false);
    const [savedSearchSocialFilters, setSavedSearchSocialFilters] = useState({
        'twitter': true,
        'facebook': true,
        'youtube': true,
        'instagram': true,
        'rss': true,
        'web': true,
        'google_ozmosys': true,
    });
    const [savedSearchSentimentFilters, setSavedSearchSentimentFilters] = useState({
        'neutral': true,
        'negative': true,
        'positive': true,
    });
    const [savedSearchSentimentCount, setSavedSearchSentimentCount] = useState({
        positive: 0,
        neutral: 0,
        negative: 0,
    });
    const [savedSearchSocialCount, setSavedSearchSocialCount] = useState({
        twitter: 0,
        facebook: 0,
        youtube: 0,
        instagram: 0,
        rss: 0,
        web: 0,
        google_ozmosys: 0
    });
    const [savedSearchPeriodFilter, setSavedSearchPeriodFilter] = useState(30);
    const [selectedEntities, setSelectedEntities] = useState([]);
    const [activeSavedSearchSort, setActiveSavedSearchSort] = useState(0);
    const [sliderVisible, setSliderVisible] = useState(false);
    const [deletedSavedSearchId, setDeletedSavedSearchId] = useState(null);

    useEffect(() => {
        if(location.pathname.slice(0, 15) !== '/saved-searches') {
            resetSavedSearchForm(null);
        }
    }, [location.pathname])

    const resetSavedSearchForm = () => {
        setSavedSearchSocialFilters({
            'twitter': true,
            'facebook': true,
            'youtube': true,
            'instagram': true,
            'rss': true,
            'web': true,
            'google_ozmosys' : true
        });
        setSavedSearchSentimentFilters({
            'neutral': true,
            'negative': true,
            'positive': true,
        });
        setSavedSearchSentimentCount({
            positive: 0,
            neutral: 0,
            negative: 0,
        });
        setSavedSearchSocialCount({
            twitter: 0,
            facebook: 0,
            youtube: 0,
            instagram: 0,
            rss: 0,
            web: 0,
            google_ozmosys: 0
        });
        setSavedSearchPeriodFilter(30);
        setSliderVisible(false);
        setActiveSavedSearch(null);
    };

    return (
        <SavedSearchContext.Provider value={{
            activeSavedSearch,
            setActiveSavedSearch,
            savedSearchSocialFilters,
            setSavedSearchSocialFilters,
            savedSearchSentimentFilters,
            setSavedSearchSentimentFilters,
            savedSearchPeriodFilter,
            setSavedSearchPeriodFilter,
            selectedEntities,
            setSelectedEntities,
            activeSavedSearchSort,
            setActiveSavedSearchSort,
            savedSearchSentimentCount,
            setSavedSearchSentimentCount,
            savedSearchSocialCount,
            setSavedSearchSocialCount,
            sliderVisible,
            setSliderVisible,
            updatingSavedSearchCount,
            setUpdatingSavedSearchCount,
            deletedSavedSearchId,
            setDeletedSavedSearchId,
            resetSavedSearchForm,
        }}>
            {props.children}
        </SavedSearchContext.Provider>
    );
};

export default SavedSearchContextProvider;